import { IconContent } from '@icons';

export const infoCircleFilled: IconContent = {
    sm: '<path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm0-9a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm.62 6V7H7.37v5h1.25Z" />',
    md: '<path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0-12a1.25 1.25 0 1 1 0-2.5A1.25 1.25 0 0 1 12 9Zm.75 1v7h-1.5v-7h1.5Z" />',
};
